import React, { useEffect, useState } from 'react';
import {
    Box, CssBaseline, CircularProgress, Grid, Typography, Button
  } from '@material-ui/core';
import { useStyles } from './styles';
import CustomBreadcrum from '../Breadcrum';
import { useHistory } from 'react-router-dom';
import { getLmaDetails, downloadLmaDocument, downloadSupportedLmaDocument, submitLMARequest, getSpocDetails } from '../../actions';
import { renderDefaultMsg, getAppSource, getUserType, isAdminCheck } from '../../helpers';
import { RequestSubmitPopup } from './RequestSubmitPopup';
import { decrypt } from '../../helpers/encrypt';
import image from '../../assets/image.png';
import pdf from '../../assets/pdf.png';
import Cookies from 'js-cookie';
import moment from 'moment';

export const LmaDetailsPreview = (props) => {

  const classes = useStyles();
  const history = useHistory();

  const [errMessage, setErrorMessage] = useState();
  const [lmaSupportDocuments, setLmaSupportDocuments] = useState([]);
  const [loading, setLoader] = useState(false);
  const [submitLoader, setSubmitLoader] = useState(false);

  const [showSubmitPopup, setSubmitPopupStatus] = useState(false);
  const [hardshipDetails, setHardshipDetails] = React.useState({
    hardshipDate: "",
    hardshipDuration: "",
    hardshipLocalFileName: "",
    hardshipS3Path: "",
    hardshipSummary: "",
    isSellProperty: false,
    jiraID: '',
    lmaApplicationId: '',
    lmaStatus: '',
    packageS3Path: '',
    purchasLocalFileName: '',
    purchaseOfferS3S3Path: '',
    retalorEmailId: '',
    retalorName: '',
    retalorPhone: '',
    listingLocalFileName: '',
    listingDocumentS3Path: ''
  });
    
  useEffect(() => {
    if (props.accountNumber) {
      getLmaDetail(props)
      getSpocDetail(props)
    }
  }, [props])
  
  const submitRequest = async () => {
    setSubmitLoader(true)
    const data = {
      "accountNumber": props.accountNumber,
      "lmaApplicationId": hardshipDetails.lmaApplicationId,
      "privateLabelUrl": Cookies.get("privateLabelUrl"),
      "ipAddress": Cookies.get('publicIp'),
      "browser": Cookies.get("browser"),
      "appSource": getAppSource(),
      "userType": getUserType(),
      "userName": ""
    };
    const response = await submitLMARequest(data)
    if (response) {
      setSubmitLoader(false)
      setErrorMessage()
      setSubmitPopupStatus(true)
    } else {
      setSubmitLoader(false)
      setErrorMessage(renderDefaultMsg('400'))
    }
  }

  const closeRequestPopup = () => {
    setSubmitPopupStatus(false)
    history.push('/LmaStatus')
  }

  const downloadDocuments = async (name, type) => {
    const data = {
      "accountNumber": props.accountNumber,
      "lmaApplicationId": hardshipDetails.lmaApplicationId,
      "documentType": type,
      "privateLabelUrl": Cookies.get("privateLabelUrl"),
      "ipAddress": Cookies.get('publicIp'),
      "browser": Cookies.get("browser"),
      "appSource": getAppSource(),
      "userType": getUserType(),
      "userName": ""
    };
    const response = await downloadLmaDocument(data)
    if (response) {
      setErrorMessage()
      const url = window.URL.createObjectURL(new Blob([response], { type: 'application/pdf' }));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', name);
      document.body.appendChild(link);
      link.click();
    } else {
      setErrorMessage(renderDefaultMsg('400'))
    }
  }

  const downloadSupportedDocs = async (name, id) => {
    const data = {
      "accountNumber": props.accountNumber,
      "id": id,
      "privateLabelUrl": Cookies.get("privateLabelUrl"),
      "ipAddress": Cookies.get('publicIp'),
      "browser": Cookies.get("browser"),
      "appSource": getAppSource(),
      "userType": getUserType(),
      "userName": ""
    };
    const response = await downloadSupportedLmaDocument(data)
    if (response) {
      setErrorMessage()
      const url = window.URL.createObjectURL(new Blob([response], { type: 'application/pdf' }));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', name);
      document.body.appendChild(link);
      link.click();
    } else {
      setErrorMessage(renderDefaultMsg('400'))
    }
  }

  const getLmaDetail = async (props) => {
    setLoader(true)
    const data = {
      "accountNumber": props.accountNumber,
      "lmaApplicationId" : 1,
      "privateLabelUrl": Cookies.get("privateLabelUrl"),
      "ipAddress": Cookies.get('publicIp'),
      "browser": Cookies.get("browser"),
      "appSource": getAppSource(),
      "userType": getUserType(),
      "userName": ""
    };

    const res = await getLmaDetails(data);
    if ((res?.responseData?.lstResponseStatus[0]?.statusCode === '0') || (res?.responseData?.lstResponseStatus[0]?.statusCode === 0)) {
      const hardshipDetails = res?.responseData?.responseData.hardshipDetails;
      setLoader(false)
      setErrorMessage() 
      setLmaSupportDocuments(res?.responseData?.responseData.lmaSupportDocuments);
      setHardshipDetails({
        hardshipDate: hardshipDetails.dateHardshipStarted,
        hardshipDuration: hardshipDetails.hardshipDuration,
        hardshipLocalFileName: hardshipDetails.lmaFormLocalName,
        hardshipS3Path: hardshipDetails.lmaFormPath,
        hardshipSummary: hardshipDetails.hardshipSummary,
        isSellProperty: hardshipDetails.isSellProperty,
        jiraID: hardshipDetails.jiraId,
        listingDocumentS3Path: hardshipDetails.listingDocumentPath,
        listingLocalFileName: hardshipDetails.listingLocalName,
        lmaApplicationId: hardshipDetails.lmaApplicationId,
        lmaStatus: hardshipDetails.lmaStatus,
        packageS3Path: hardshipDetails.packageS3Path,
        purchaseOfferLocalName: hardshipDetails.purchaseOfferLocalName,
        purchaseOfferS3S3Path: hardshipDetails.purchaseOfferPath,
        retalorEmailId: hardshipDetails.retalorEmailId,
        retalorName: hardshipDetails.retalorName,
        retalorPhone: hardshipDetails.retalorPhone
      });
    } else {
      setLoader(false)
      setLmaSupportDocuments([]);
      setErrorMessage(renderDefaultMsg('400'))
    }
  }
  
  const getSpocDetail = async (props) => {
    const data = {
      "accountNumber": props.accountNumber,
      "privateLabelUrl": Cookies.get("privateLabelUrl"),
      "ipAddress": Cookies.get('publicIp'),
      "browser": Cookies.get("browser"),
      "appSource": getAppSource(),
      "userType": getUserType(),
      "userName": ""
    };

    const res = await getSpocDetails(data);
    if (res?.responseData?.lstResponseStatus[0]?.statusCode == 0) {
      getLMAStatus(res?.responseData?.responseData.lmaStatus)
    } 
  }

  const getLMAStatus = (lmaStatus) => {
    if ((lmaStatus.toLowerCase() == "spoc") || (lmaStatus.toLowerCase() == 'lma not allowed')) {
      history.push('/FinancialHardship')
    } else if ((lmaStatus.toLowerCase() !== "in progress") && (lmaStatus.toLowerCase() !== "blank")) {
      history.push('/LmaStatus')
    } 
  }

  if (loading) {
    return (
      <Box className={classes.loadingRoot}>
        <CircularProgress />
      </Box>
    )
  } 

  return (
    <CssBaseline>
      <>
       <Box container="true" maxWidth='xl' className={classes.root}>      
        <Box className={classes.container}>
          <CustomBreadcrum backPage="Payments" backPageLink="/PaymentOption" activePage="Financial Hardship" />
              <h1 className={classes.pageHeading} color="textPrimary" component='h4'>Loss Mitigation Application</h1>
              <Box className={classes.infoStrip}>
                <Grid container spacing={1} justifyContent="space-around" columns={{ xs: 12, sm: 12, md: 12 }} >
                    <Grid item xs={12} sm={12} md={8} >
                      <p className={classes.heading}>PROCEED & PREVIEW</p>
                    </Grid>
                
                    <Grid item xs={12} sm={12} md={4} >
                    </Grid>
                 </Grid> 
                 <Box className={classes.boxContainer}>
                    <Box>
                       
                        <Box className={classes.hardshipContainer}>
                          <p className={classes.title}>Hardship Details & Loss Mitigation Form</p>   
                          <p className={classes.line}></p>
                          <Box className={classes.hardshipBox}>
                              { hardshipDetails.hardshipSummary && <>
                              <p className={classes.procedureToFill}>Hardship Summary </p>   
                              <p className={classes.readInst}>{ hardshipDetails.hardshipSummary}</p>   
                              </>}
                          
                              { hardshipDetails.hardshipDate && <>
                              <p className={classes.procedureToFill}>Date since hardship situation began is: </p>   
                              <p className={classes.readInst}> {moment(hardshipDetails.hardshipDate).format('MM/DD/YYYY')}</p> </>}
                                  <Box className={classes.marginFixed}>
                                    { (hardshipDetails.hardshipDuration !== null) && <p className={classes.procedureToFill}>I believe that my situation is:</p>}
                                    { (hardshipDetails.hardshipDuration == "short-term") && <p className={classes.readInst}>Short-term (under 6 months)</p>}  
                                    { (hardshipDetails.hardshipDuration == "medium-term") && <p className={classes.readInst}>Medium-term(6-12 months)</p>}  
                                    { (hardshipDetails.hardshipDuration == "long-term") && <p className={classes.readInst}>Long-term or permanent (greater than 12 months)</p>}                             
                                    <p className={classes.procedureToFill}> Loss Mitigation Form</p>   
                                    
                                  </Box>

                                  <Box className={classes.fileUpload}>
                                  
                                      { (hardshipDetails.hardshipS3Path != null) &&
                                          <Box>
                                            <Box className={classes.uploadedImage}>
                                                <img className={classes.checkImg} src={pdf} alt='pdf' /> 
                                                <Typography className={classes.imageText} onClick={() => downloadDocuments(hardshipDetails.hardshipLocalFileName, "LMA")}>{hardshipDetails.hardshipLocalFileName} </Typography>
                                                
                                            </Box>
                                          </Box>
                                        }
                                </Box>
                              </Box>
                            </Box>             
                          </Box>
  
                        <Box className={classes.hardshipContainer} style={{marginTop: '30px'}}>
                          <p className={classes.title}>Upload Supporting Documents</p>   
                          <p className={classes.line}></p>
                          {lmaSupportDocuments.map((documentCategory, index) => (
                            <Box>
                            {  (documentCategory.subCategory.filter((subCat) => subCat.uploadedDocs[0].uploadSupportDocPath != null).length > 0) &&
                            <>
                              <p className={classes.accordianHeading}>{documentCategory.documentCategory}</p> 
                              <p className={classes.divider}></p>
                            </> 
                            }

                           {documentCategory?.subCategory.map((subCategory) => (
                          
                          <Box className={classes.uploadDocsSection}>
                            { (subCategory?.uploadedDocs[0].uploadSupportDocPath != null) &&
                            <Box className={classes.fileUploadSection}>
                            
                            <p className={classes.procedureToFill}>{subCategory.supportDocName}</p>  

                             <Grid container>
                              { (subCategory?.uploadedDocs[0].uploadSupportDocPath != null) && subCategory?.uploadedDocs.map((key, ind) => 
                               (
                                <Grid item xs={12} sm={12} md={12}>
                                  <Box className={classes.uploadedImagesBox}>
                                    <Box className={classes.uploadedImg}>
                                        { !key.localFileName.includes('pdf') ? <img className={classes.checkImg} src={image} alt='img' /> :  <img className={classes.checkImg} src={pdf} alt='pdf' /> }
                                        <Typography className={classes.imageText} onClick={() => downloadSupportedDocs(key.localFileName, key?.uploadDocumentId)}>{key.localFileName} </Typography>
                                       
                                     </Box>
                                   </Box>
                                  </Grid>
                                  ))}
                                </Grid>   
                               </Box>}
                          </Box> 
                             
                        ))}
                        </Box>

                        
                      ))}

                    { hardshipDetails.isSellProperty &&
                      <Box>
                        <Box>
                          <p className={classes.accordianHeading}>Property Selling Documents</p>   
                          <p className={classes.line}></p>
                        </Box>
                           <Box className={classes.sellContainer}>
                            <Box className={classes.listingSection}>
                              <p className={classes.procedureToFill}>Listing Agreement</p>   
                                            
                                  <Box className={classes.uploadedImagesBox}>
                                    <Box className={classes.uploadedImg}>
                                    { !hardshipDetails.listingLocalFileName.includes('pdf') ? <img className={classes.checkImg} src={image} alt='img' /> :  <img className={classes.checkImg} src={pdf} alt='pdf' /> }
                                        <Typography className={classes.fileText} onClick={() => downloadDocuments(hardshipDetails?.listingLocalFileName, "Sale")}>{hardshipDetails?.listingLocalFileName} </Typography>
                                       
                                     </Box>
                                   </Box>
                               </Box>

                              {(hardshipDetails.purchaseOfferS3S3Path) &&
                              <Box>
                                <p className={classes.procedureToFill}>Purchase Offer </p>   
                                    <Box className={classes.uploadedImagesBox}>
                                      <Box className={classes.uploadedImg}>
                                      { !hardshipDetails.purchaseOfferLocalName.includes('pdf') ? <img className={classes.checkImg} src={image} alt='img' /> :  <img className={classes.checkImg} src={pdf} alt='pdf' /> }
                                          <Typography className={classes.fileText} onClick={() => downloadDocuments(hardshipDetails?.purchaseOfferLocalName, "Purchase")}>{hardshipDetails?.purchaseOfferLocalName} </Typography>
  
                                      </Box>
                                    </Box>
                               </Box> }

                               <Box className={classes.realtorSection}>
                                <p className={classes.procedureToFill}>Realtor Information</p>   

                                <Grid container>
                                  <Grid item  md={2} xs={12} lg={2}>
                                    <p className={classes.info}>Name:</p>   
                                    <p className={classes.procedureToFill}>{hardshipDetails.retalorName}</p>   
                                  </Grid>
                                 {hardshipDetails?.retalorPhone && <Grid item  md={3} xs={12} lg={3}>
                                    <p className={classes.info}>Phone Number:</p>   
                                    <p className={classes.procedureToFill}>{decrypt(hardshipDetails?.retalorPhone)}</p>   
                                  </Grid> }
                                  {hardshipDetails?.retalorEmailId && <Grid item  md={2} xs={12} lg={2}>
                                    <p className={classes.info}>Email:</p>   
                                  {<p className={classes.procedureToFill}>{decrypt(hardshipDetails?.retalorEmailId)}</p>}   
                                  </Grid> }
                                  </Grid>
                                  <p className={classes.errorMsg} dangerouslySetInnerHTML={{ __html: errMessage !== '' ? errMessage : '' }} />

                               </Box>
                            </Box>   
                        </Box> }
                     
                        { !hardshipDetails.isSellProperty &&
                          <Box>
                            <Box>
                              <p className={classes.accordianHeading}>Planning to Sell Property</p>   
                              <p className={classes.line}></p>
                            </Box>
                              <Box className={classes.sellContainer}>
                                <Box className={classes.listingSection}>
                                  <p className={classes.procedureToFill}>No</p> 
                                  </Box>
                                </Box> 
                            </Box> }
                        </Box>
                      
                        <Box className={classes.footerSection}>
                              <Grid container style={{ marginTop: '12px' }}>
                                  <Grid item xs={6} md={6} className={classes.pr35}>
                                      <Box className={classes.cancelBtnBox}>
                                      <Button
                                          className={classes.cancelBtn}
                                          variant="outlined"
                                          onClick={() => history.push('/LmaDetails')}
                                      >BACK</Button>
                                      </Box>
                                  </Grid>
                                  <Grid item xs={6} md={6} className={classes.pl35}>
                                      <Box className={classes.saveBtnBox}>
                                      {submitLoader ?
                                        <Button disabled={true} type='submit' className={classes.saveBtn} variant="contained" color='primary'>
                                          <CircularProgress color='primary' />
                                        </Button>
                                        :
                                        <Button
                                          className={classes.saveBtn}
                                          variant="contained"
                                          onClick={submitRequest}
                                          disabled={isAdminCheck()}
                                          color="primary">
                                          SUBMIT</Button> }
                                      </Box>
                                  </Grid>
                              </Grid>
                          </Box>
                  </Box>

                </Box>
            </Box>
          </Box>
          { showSubmitPopup &&
            <RequestSubmitPopup 
              open={showSubmitPopup}
              handleCancelIcon={closeRequestPopup}
            />
          }
     </> 
    </CssBaseline>
  )
}

